<template>
  <b-form>
    <!-- <b-form-select id="pilihDosen" v-model="selected" :options="options"></b-form-select> -->
    <Select2 v-model="selectedValue" :options="options" @change="changelecturer($event)"
      :settings="{ multiple: statusMultiple, width: '100%' }" />
  </b-form>
</template>

<script>
import axios from "axios"
export default {
  data() {
    return {
      selected: null,
      options: [
        { value: null, text: '--Pilih Dosen--' },
      ],
    };
  },
  props: {
    changelecturer: Function,
    selectedValue: String,
    statusMultiple: Boolean,
  },
  async mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      await axios.get('master/lecturers')
        .then(response => {
          if (response.status == 200) {
            response.data.data.some((e, index) => {
              var object = { "id": e.key, "text": e.name }
              this.options.push(object);
              return index > e.length;
            });
          }
        })
    },
  },
}
</script>